import { render } from "./ComOhjeSahkoluokka.vue?vue&type=template&id=f8673590&ts=true"
import script from "./ComOhjeSahkoluokka.vue?vue&type=script&lang=ts"
export * from "./ComOhjeSahkoluokka.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__